import { IN_NODE } from './compat';

export const BASE_URL = IN_NODE ? __dirname + '/' : 'https://webr.r-wasm.org/v0.6.0/';
export const PKG_BASE_URL = 'https://repo.r-wasm.org';
export const WEBR_VERSION = '0.6.0';
export const R_VERSION = '4.6.0';
